const _ = require('lodash');
const $ = require('jquery');
const Documents = require('./documents');
const ActionPanel = require('./action-panel');
const ExportResult = require('./export-result');
const ExportResultUpload = require('./export-result-upload');
const OrdersOptions = require('./orders-options');
const css = require('./current-order.css');
const EditableOrder = require('./editable-order');
const Price = require('./price');
const IndividualOrderParameters = require('./individual-order-parameters');
const Header = require('./header');
const Overlay = require('../../../layout/overlay');
const signals = require('../../../../signals/groups/account');
const Preloader = require('../../../layout/preloader');
const StatisticBlock = require('./statistic-block');
const ordersComputedActions = require('../../../../actions/computed/account/orders');
const currentOrderActions = require('../../../../actions/account/current-order');

const IS_STICKED = css.isSticked;
const IS_STICKED2 = css.isSticked2;

class Orders {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        this.$context.signal(signals.getExportResults);
        this.$context.signal(signals.getOrderState);
        this.$context.signal(signals.getHasBitrixLeads);

        this.initScroller();
    }

    unbind () {
        $(window).unbind('scroll', this._scrollHandler);
    }

    initScroller () {
        this.headerHeight = $('#orderHeader').offset().top;
        this.wrapperElement = $('#orderHeader');

        this.wrapperElement2 = $('#orderParametersHeader');
        const wrapperElement2Offset = this.wrapperElement2.offset();
        this.headerHeight2 = wrapperElement2Offset ? wrapperElement2Offset.top : 0;

        this._scrollHandler = _.bind(this.scrollHandler, this);

        $(window).scroll(this._scrollHandler);
        this.scrollHandler();
    }

    scrollHandler () {
        const topView = $(window).scrollTop();
        const viewLessHeader = topView >= this.headerHeight;
        const viewLessHeader2 = topView >= this.headerHeight2;

        this.wrapperElement.toggleClass(IS_STICKED, viewLessHeader);
        this.wrapperElement2.toggleClass(IS_STICKED2, viewLessHeader2);
    }
}

module.exports = {
    constructor: Orders,
    children: [
        {
            name: 'overlay',
            component: Overlay,
            watcher: {
                isLoading: ['account', 'orders', 'currentOrder', 'isLoading']
            }
        },
        {
            name: 'documents',
            component: Documents,
            watcher: {
                documents: ['account', 'orders', 'currentOrder', 'necessaryDocuments'],
                showNecessaryDocumentsAddDeleteButtons: ordersComputedActions.PATHS.showNecessaryDocumentsAddDeleteButtons,
                showUploadFailTooltip: currentOrderActions.PATHS.showUploadFailTooltip,
                showDocumentsWillBeUploadedTooltip: ['account', 'orders', 'computed', 'componentsState',
                    'showDocumentsWillBeUploadedTooltip'],
                showBillDocumentMustBeAttached: currentOrderActions.PATHS.showBillDocumentMustBeAttached,
                showBillDraftDownloadButton: ['account', 'orders', 'computed', 'componentsState',
                    'showBillDraftDownloadButton'],
                orderId: ['account', 'orders', 'currentOrder', 'id']
            }
        },
        {
            name: 'action-panel',
            component: ActionPanel,
            watcher: {
                showLicenseAgreementCheckbox: ['account', 'orders', 'computed', 'componentsState',
                    'showLicenseAgreementCheckbox'],
                showLicenseMustBeAccepted: ['account', 'orders', 'currentOrder', 'tooltips',
                    'showLicenseMustBeAccepted'],
                showContinueButton: ['account', 'orders', 'computed', 'componentsState', 'showContinueButton'],
                showMakeOrderButton: ['account', 'orders', 'computed', 'componentsState', 'showMakeOrderButton'],
                showPayOnlineButton: ['account', 'orders', 'computed', 'componentsState', 'showPayOnlineButton'],
                showArchiveButton: ['account', 'orders', 'computed', 'componentsState', 'showArchiveButton'],
                showSaveAllButton: ['account', 'orders', 'computed', 'componentsState', 'showSaveAllButton'],
                continueButtonLabel: ['account', 'orders', 'computed', 'componentsState', 'continueButtonLabel'],
                showRepeatButton: ['account', 'orders', 'computed', 'componentsState', 'showRepeatButton'],
                showBitrixExportButton: ['account', 'orders', 'computed', 'componentsState', 'showBitrixExportButton'],
                showFreeBitrixExportButton: ['account', 'orders', 'computed', 'componentsState',
                    'showFreeBitrixExportButton'],
                disableContinue: ['account', 'orders', 'disableContinue'],
                hasBitrixLeads: ['account', 'orders', 'currentOrder', 'hasBitrixLeads'],
                isBitrix: ['bitrix', 'isBitrix'],
                exportResult: ['account', 'orders', 'currentOrder', 'exportResult'],
                isManager: ['user', 'isManager']
            }
        },
        {
            name: 'export-result',
            component: ExportResult,
            watcher: {
                exportResult: ['account', 'orders', 'currentOrder', 'exportResult'],
                showDownloadAllButton: ['account', 'orders', 'computed', 'componentsState', 'showDownloadAllButton'],
                isCanDeleteResult: ordersComputedActions.PATHS.isCanDeleteResult
            }
        },
        {
            name: 'export-result-upload',
            component: ExportResultUpload,
            watcher: {
                isExportResultMustBeAttached: currentOrderActions.PATHS.isExportResultMustBeAttached
            }
        },
        {
            name: 'custom-order',
            component: EditableOrder,
            watcher: {
                isEditable: ['account', 'orders', 'computed', 'currentOrder', 'isEditable']
            }
        },
        {
            name: 'price',
            component: Price,
            watcher: {
                isShowAsterisk: ordersComputedActions.PATHS.isShowSumCanChangeTooltip,
                rowPrice: ['account', 'orders', 'computed', 'price', 'data', 'total', 'rowPrice'],
                totalPrice: ['account', 'orders', 'computed', 'price', 'data', 'total', 'totalPrice'],
                rowAmount: ['account', 'orders', 'computed', 'price', 'data', 'total', 'rowAmount'],
                isLoading: ['account', 'orders', 'computed', 'price', 'isLoading']
            }
        },
        {
            name: 'individual-order-parameters',
            component: IndividualOrderParameters,
            watcher: {
                showPriceMustBeBiggerThanZero: currentOrderActions.PATHS.showPriceMustBeBiggerThanZero,
                orderAmountError: currentOrderActions.PATHS.orderAmountError
            }
        },
        {
            name: 'orders-options',
            component: OrdersOptions,
            watcher: {
                showManager: ['account', 'orders', 'computed', 'componentsState', 'showManager'],
                showUser: ['account', 'orders', 'computed', 'componentsState', 'showUser'],
                showPaymentType: ['account', 'orders', 'computed', 'componentsState', 'showPaymentType'],
                showManagerSelect: ['account', 'orders', 'computed', 'componentsState', 'showManagerSelect'],
                showUserSelect: ['account', 'orders', 'computed', 'componentsState', 'showUserSelect'],
                managerName: ['account', 'orders', 'computed', 'currentOrder', 'manager', 'fullName'],
                managerEmail: ['account', 'orders', 'currentOrder', 'manager', 'email'],
                userName: ['account', 'orders', 'computed', 'currentOrder', 'user', 'fullName'],
                totalPrice: ['account', 'orders', 'computed', 'price', 'data', 'total', 'totalPrice'],
                showUserMustBeSelected: ['account', 'orders', 'currentOrder', 'tooltips', 'showUserMustBeSelected'],
                showPaymentTypeChangePanel: ['account', 'orders', 'computed', 'componentsState',
                    'showPaymentTypeChangePanel'],
                onlinePaymentDisabled: ['account', 'orders', 'computed', 'componentsState',
                    'onlinePaymentDisabled'],
                paymentName: ['account', 'orders', 'computed', 'currentOrder', 'paymentName'],
                isManager: ['user', 'isManager'],
                userId: ['account', 'orders', 'currentOrder', 'user', 'id']
            }
        },
        {
            name: 'header',
            component: Header,
            watcher: {
                id: ['account', 'orders', 'currentOrder', 'id'],
                createDate: ['account', 'orders', 'computed', 'currentOrder', 'createDate'],
                stateName: ['account', 'orders', 'computed', 'currentOrder', 'stateName']
            }
        },
        {
            name: 'preloader',
            component: Preloader,
            props: {
                size: 'medium'
            }
        },
        {
            name: 'statistic-block',
            component: StatisticBlock,
            watcher: {
                id: ['account', 'orders', 'currentOrder', 'id'],
                showOrderStatistic: ['account', 'orders', 'computed', 'componentsState', 'showOrderStatistic'],
                isOrderChanging: ['account', 'orders', 'currentOrder', 'filterValuesChanged'],
                orderCitiesTab: ['order', 'cities', 'tab']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/index.js